import { hasBrandAdminAccess, isOmsPlatformAdmin } from './adminAccess'

/** Top-level admin sales home (Crow’s Nest + Catch Board + Spartacus + Harbour). */
export const BRIDGE_ADMIN_PATH = '/admin/the-bridge'
export const BRIDGE_ADMIN_TAB_KEY = 'the-bridge'
export const BRIDGE_ADMIN_LABEL = 'The Bridge'

/** Pre-Bridge bookmark / deep link — redirect to The Bridge. */
export const BRIDGE_ADMIN_LEGACY_SPARTACUS_PATH = '/admin/spartacus'

export {
  BRIDGE_DEFAULT_MINI_TAB,
  BRIDGE_MINI_TAB_CROWS_NEST,
  BRIDGE_MINI_TAB_QUERY,
  BRIDGE_MINI_TAB_SPARTACUS,
  BRIDGE_MINI_TABS,
  BRIDGE_PAGE_SUBTITLE,
  BRIDGE_PAGE_TITLE,
  buildBridgeAdminPath,
  getBridgeMiniTabFromSearch,
  isBridgeMiniTabKey,
  resolveBridgeMiniTab,
} from '../constants/bridge'

export function shouldShowBridgeAdminTab(account) {
  return isOmsPlatformAdmin(account)
}

export function canAccessBridgeAdminRoute(account) {
  return isOmsPlatformAdmin(account)
}

export function getAdminNavTabKeys(account) {
  const brandAdminAccess = hasBrandAdminAccess(account)
  const keys = [
    'orders',
    'spending',
    'products',
    'suppliers',
    'supplier-invites',
    'accounts',
  ]

  if (shouldShowBridgeAdminTab(account)) {
    keys.push(BRIDGE_ADMIN_TAB_KEY)
  }

  if (!brandAdminAccess) {
    keys.push('invoice-exceptions')
  }

  return keys
}

// --- Spartacus-named aliases (same gate / Bridge path) ---
export const SPARTACUS_ADMIN_PATH = BRIDGE_ADMIN_PATH
export const SPARTACUS_ADMIN_TAB_KEY = BRIDGE_ADMIN_TAB_KEY
export const shouldShowSpartacusAdminTab = shouldShowBridgeAdminTab
export const canAccessSpartacusAdminRoute = canAccessBridgeAdminRoute
